export { default as VendorsEdit } from './VendorsEdit';
export { default as VendorsList } from './VendorsList';